export enum COUNTRY_CODE_NAMES {
    AD = "Principality of Andorra",
    AE = "United Arab Emirates",
    AF = "Islamic Republic of Afghanistan",
    AG = "Antigua and Barbuda",
    AI = "Anguilla",
    AL = "Republic of Albania",
    AM = "Republic of Armenia",
    AO = "Republic of Angola",
    AQ = "Antarctica",
    AR = "Argentine Republic",
    AS = "American Samoa",
    AT = "Republic of Austria",
    AU = "Commonwealth of Australia",
    AW = "Aruba",
    AX = "Åland Islands",
    AZ = "Republic of Azerbaijan",
    BA = "Bosnia and Herzegovina",
    BB = "Barbados",
    BD = "People's Republic of Bangladesh",
    BE = "Kingdom of Belgium",
    BF = "Burkina Faso",
    BG = "Republic of Bulgaria",
    BH = "Kingdom of Bahrain",
    BI = "Republic of Burundi",
    BJ = "Republic of Benin",
    BL = "Collectivity of Saint Barthélemy",
    BM = "Bermuda",
    BN = "Nation of Brunei, Abode of Peace",
    BO = "Plurinational State of Bolivia",
    BQ = "Bonaire, Sint Eustatius and Saba",
    BR = "Federative Republic of Brazil",
    BS = "Commonwealth of the Bahamas",
    BT = "Kingdom of Bhutan",
    BV = "Bouvet Island",
    BW = "Republic of Botswana",
    BY = "Republic of Belarus",
    BZ = "Belize",
    CA = "Canada",
    CC = "Territory of the Cocos (Keeling) Islands",
    CD = "Democratic Republic of the Congo",
    CF = "Central African Republic",
    CG = "Republic of the Congo",
    CH = "Swiss Confederation",
    CI = "Republic of Côte d'Ivoire",
    CK = "Cook Islands",
    CL = "Republic of Chile",
    CM = "Republic of Cameroon",
    CN = "People's Republic of China",
    CO = "Republic of Colombia",
    CR = "Republic of Costa Rica",
    CU = "Republic of Cuba",
    CV = "Republic of Cabo Verde",
    CW = "Country of Curaçao",
    CX = "Territory of Christmas Island",
    CY = "Republic of Cyprus",
    CZ = "Czech Republic",
    DE = "Federal Republic of Germany",
    DJ = "Republic of Djibouti",
    DK = "Kingdom of Denmark",
    DM = "Commonwealth of Dominica",
    DO = "Dominican Republic",
    DZ = "People's Democratic Republic of Algeria",
    EC = "Republic of Ecuador",
    EE = "Republic of Estonia",
    EG = "Arab Republic of Egypt",
    EH = "Sahrawi Arab Democratic Republic",
    ER = "State of Eritrea",
    ES = "Kingdom of Spain",
    ET = "Federal Democratic Republic of Ethiopia",
    FI = "Republic of Finland",
    FJ = "Republic of Fiji",
    FK = "Falkland Islands",
    FM = "Federated States of Micronesia",
    FO = "Faroe Islands",
    FR = "French Republic",
    GA = "Gabonese Republic",
    GB = "United Kingdom of Great Britain and Northern Ireland",
    GD = "Grenada",
    GE = "Georgia",
    GF = "Guiana",
    GG = "Bailiwick of Guernsey",
    GH = "Republic of Ghana",
    GI = "Gibraltar",
    GL = "Greenland",
    GM = "Republic of the Gambia",
    GN = "Republic of Guinea",
    GP = "Guadeloupe",
    GQ = "Republic of Equatorial Guinea",
    GR = "Hellenic Republic",
    GS = "South Georgia and the South Sandwich Islands",
    GT = "Republic of Guatemala",
    GU = "Guam",
    GW = "Republic of Guinea-Bissau",
    GY = "Co-operative Republic of Guyana",
    HK = "Hong Kong Special Administrative Region of the People's Republic of China",
    HM = "Heard Island and McDonald Islands",
    HN = "Republic of Honduras",
    HR = "Republic of Croatia",
    HT = "Republic of Haiti",
    HU = "Hungary",
    ID = "Republic of Indonesia",
    IE = "Republic of Ireland",
    IL = "State of Israel",
    IM = "Isle of Man",
    IN = "Republic of India",
    IO = "British Indian Ocean Territory",
    IQ = "Republic of Iraq",
    IR = "Islamic Republic of Iran",
    IS = "Iceland",
    IT = "Italian Republic",
    JE = "Bailiwick of Jersey",
    JM = "Jamaica",
    JO = "Hashemite Kingdom of Jordan",
    JP = "Japan",
    KE = "Republic of Kenya",
    KG = "Kyrgyz Republic",
    KH = "Kingdom of Cambodia",
    KI = "Independent and Sovereign Republic of Kiribati",
    KM = "Union of the Comoros",
    KN = "Federation of Saint Christopher and Nevisa",
    KP = "Democratic People's Republic of Korea",
    KR = "Republic of Korea",
    KW = "State of Kuwait",
    KY = "Cayman Islands",
    KZ = "Republic of Kazakhstan",
    LA = "Lao People's Democratic Republic",
    LB = "Lebanese Republic",
    LC = "Saint Lucia",
    LI = "Principality of Liechtenstein",
    LK = "Democratic Socialist Republic of Sri Lanka",
    LR = "Republic of Liberia",
    LS = "Kingdom of Lesotho",
    LT = "Republic of Lithuania",
    LU = "Grand Duchy of Luxembourg",
    LV = "Republic of Latvia",
    LY = "State of Libya",
    MA = "Kingdom of Morocco",
    MC = "Principality of Monaco",
    MD = "Republic of Moldova",
    ME = "Montenegro",
    MF = "Saint Martin",
    MG = "Republic of Madagascar",
    MH = "Republic of the Marshall Islands",
    MK = "Republic of Macedonia",
    ML = "Republic of Mali",
    MM = "Republic of the Union of Myanmar",
    MN = "Mongolia",
    MO = "Macao Special Administrative Region of the People's Republic of China",
    MP = "Commonwealth of the Northern Mariana Islands",
    MQ = "Martinique",
    MR = "Islamic Republic of Mauritania",
    MS = "Montserrat",
    MT = "Republic of Malta",
    MU = "Republic of Mauritius",
    MV = "Republic of the Maldives",
    MW = "Republic of Malawi",
    MX = "United Mexican States",
    MY = "Malaysia",
    MZ = "Republic of Mozambique",
    NA = "Republic of Namibia",
    NC = "New Caledonia",
    NE = "Republic of Niger",
    NF = "Territory of Norfolk Island",
    NG = "Federal Republic of Nigeria",
    NI = "Republic of Nicaragua",
    NL = "Netherlands",
    NO = "Kingdom of Norway",
    NP = "Federal Democratic Republic of Nepal",
    NR = "Republic of Nauru",
    NU = "Niue",
    NZ = "New Zealand",
    OM = "Sultanate of Oman",
    PA = "Republic of Panama",
    PE = "Republic of Peru",
    PF = "French Polynesia",
    PG = "Independent State of Papua New Guinea",
    PH = "Republic of the Philippines",
    PK = "Islamic Republic of Pakistan",
    PL = "Republic of Poland",
    PM = "Saint Pierre and Miquelon",
    PN = "Pitcairn Group of Islands",
    PR = "Commonwealth of Puerto Rico",
    PS = "State of Palestine",
    PT = "Portuguese Republic",
    PW = "Republic of Palau",
    PY = "Republic of Paraguay",
    QA = "State of Qatar",
    RE = "Réunion Island",
    RO = "Romania",
    RS = "Republic of Serbia",
    RU = "Russian Federation",
    RW = "Republic of Rwanda",
    SA = "Kingdom of Saudi Arabia",
    SB = "Solomon Islands",
    SC = "Republic of Seychelles",
    SD = "Republic of the Sudan",
    SE = "Kingdom of Sweden",
    SG = "Republic of Singapore",
    SH = "Saint Helena, Ascension and Tristan da Cunha",
    SI = "Republic of Slovenia",
    SJ = "Svalbard og Jan Mayen",
    SK = "Slovak Republic",
    SL = "Republic of Sierra Leone",
    SM = "Most Serene Republic of San Marino",
    SN = "Republic of Senegal",
    SO = "Federal Republic of Somalia",
    SR = "Republic of Suriname",
    SS = "Republic of South Sudan",
    ST = "Democratic Republic of São Tomé and Príncipe",
    SV = "Republic of El Salvador",
    SX = "Sint Maarten",
    SY = "Syrian Arab Republic",
    SZ = "Kingdom of Swaziland",
    TC = "Turks and Caicos Islands",
    TD = "Republic of Chad",
    TF = "Territory of the French Southern and Antarctic Lands",
    TG = "Togolese Republic",
    TH = "Kingdom of Thailand",
    TJ = "Republic of Tajikistan",
    TK = "Tokelau",
    TL = "Democratic Republic of Timor-Leste",
    TM = "Turkmenistan",
    TN = "Tunisian Republic",
    TO = "Kingdom of Tonga",
    TR = "Republic of Turkey",
    TT = "Republic of Trinidad and Tobago",
    TV = "Tuvalu",
    TW = "Republic of China (Taiwan)",
    TZ = "United Republic of Tanzania",
    UA = "Ukraine",
    UG = "Republic of Uganda",
    UM = "United States Minor Outlying Islands",
    US = "United States of America",
    UY = "Oriental Republic of Uruguay",
    UZ = "Republic of Uzbekistan",
    VA = "Vatican City State",
    VC = "Saint Vincent and the Grenadines",
    VE = "Bolivarian Republic of Venezuela",
    VG = "Virgin Islands",
    VI = "Virgin Islands of the United States",
    VN = "Socialist Republic of Vietnam",
    VU = "Republic of Vanuatu",
    WF = "Territory of the Wallis and Futuna Islands",
    WS = "Independent State of Samoa",
    YE = "Republic of Yemen",
    YT = "Department of Mayotte",
    ZA = "Republic of South Africa",
    ZM = "Republic of Zambia",
    ZW = "Republic of Zimbabwe",
}

export enum LANGUAGE_CODES {
    CS = "Czech",
    DE = "German",
    EN = "English",
    ES = "Spanish",
    FR = "French",
    IT = "Italian",
    LT = "Lithuanian",
    LV = "Latvian",
    NL = "Dutch",
    PL = "Polish",
    RO = "Romanian",
    SK = "Slovak",
}
